export function getIso31662db() {
    return import(/* webpackChunkName: "iso3166-2-db" */ 'iso3166-2-db')
        .then(x=>x)
        .catch(err=>{console.error("error loading iso3166-2-db")});
}
export function getIso31662dbCountries(){
    return getIso31662db().then( iso31662db => {
            let listOfCountries = iso31662db.reduce(iso31662db.getDataSet(), "en");
            return {
                listOfCountries,
                countries: Object.keys(listOfCountries)
                    .map(key => listOfCountries[key])
                    .sort((a, b) => a.name.localeCompare(b.name))
            };
        }
    );
}
